// Angular
import { AppModule } from "../app/app.module";

import { SBSuiteManager } from '../modules/sbsuite/providers/sbsuite.manager';

import { AutoClocking } from '../pages/auto-clocking/auto-clocking';
import { ManuallyClocking } from '../pages/manually-clocking/manually-clocking';

// See docs for Typescript @decorator
// => https://www.typescriptlang.org/docs/handbook/decorators.html
// => https://angular-2-training-book.rangle.io/handout/features/decorators.html
// => https://toddmotto.com/angular-decorators

/**
 * Variable para desactivar el decorator.
 * 
 * @TODO: Eliminar en el caso de producción, solo desarrollo.
 */
const BY_PASS = false;

/**
 * Decorador para redirigir si el usuario no está autenticado.
 */
export function RedirectOnUserAttr(defRedirectRoute = 'Login'){

    return function (constructor) {
        const originalDidEnter = constructor.prototype.ionViewDidEnter;
        const originalWillEnter = constructor.prototype.ionViewWillEnter;
        const originalDidLeave = constructor.prototype.ionViewDidLeave;

        constructor.prototype.ionViewWillEnter = function () {
            const sbSuiteManager = AppModule.injector.get(SBSuiteManager);

            if(this.navCtrl === undefined) {
                throw new Error("@Role requires the target component to have a property called 'navCtrl' that is the injected NavController");
            }else {
                let listener = sbSuiteManager.authSubject.subscribe(
                    user=>{
                        if(BY_PASS) return;
                        let instance = this.navCtrl.first().instance;

                        if(user.level < 1) this.navCtrl.setRoot('Login').then(()=>this.sbSuiteManager.isLoaded=true);
                        else if(user.level < 9){
                            if(!(user.params.fichajestiemporeal) && (instance instanceof AutoClocking)){
                                this.navCtrl.setRoot('ManuallyClocking').then(()=>this.sbSuiteManager.isLoaded=true);
                            }  
                            else if(user.params.fichajestiemporeal && instance instanceof ManuallyClocking){
                                this.navCtrl.setRoot('AutoClocking').then(()=>this.sbSuiteManager.isLoaded=true);
                            }
                        }
                        else{
                            if(!(user.params.fichajestiemporeal) && (instance instanceof AutoClocking)){
                                this.navCtrl.setRoot('ManuallyClocking').then(()=>this.sbSuiteManager.isLoaded=true);
                            }
                        }
                    },
                    error=>{
                        this.navCtrl.setRoot(defRedirectRoute).then(()=>this.sbSuiteManager.isLoaded=true);
                       // listener.unsubscribe();
                    }
                );
            }

            // Call the ionViewDidEnter event defined in the page
            originalWillEnter && typeof originalWillEnter === 'function' && originalWillEnter.apply(this, arguments);
        };

        constructor.prototype.ionViewDidEnter = function () {
            originalDidEnter && typeof originalDidEnter === 'function' && originalDidEnter.apply(this, arguments);
        };

        constructor.prototype.ionViewDidLeave = function () {
            originalDidLeave && typeof originalDidLeave === 'function' && originalDidLeave.apply(this, arguments);
        };
    }

}



// WEBPACK FOOTER //
// ./src/decorators/redirect-on-user-attr.decorator.ts